import { Button } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { useAPIResource, useAuth } from "@/hooks"
import { queryKeys, userAPI } from "@/utils"

export function LanguageButton() {
  const { i18n } = useTranslation()
  const { update } = useAPIResource(userAPI, { invalidate: queryKeys.auth })
  const { user } = useAuth()

  return (
    <Button
      px={0}
      variant="transparent"
      color="gray.7"
      onClick={() => {
        const value = i18n.language == "en" ? "ru" : "en"
        i18n.changeLanguage(value)
        if (user) {
          update({ id: user.id, locale: value })
        }
      }}
    >
      {i18n.language.toUpperCase()}
    </Button>
  )
}
